import DateFormat from '@/Enums/Format/DateFormat.enum';
import DateRangeWithShortcuts from '@/components/DateRangeWithShortcuts';
import { dateRangeToFormat, dateToFormat } from '@/helpers/valueFormatter/dateFormatter.helpers';
import type { DateRange } from '@mui/x-date-pickers-pro';
import moment, { type Moment } from 'moment';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

const getDateRange = (dates: [string, string]): DateRange<Moment> => {
  if (!dates?.length || dates.some(date => !date)) {
    return [moment(), moment()];
  }
  return [moment(dates[0]), moment(dates[1] ?? dates[0])];
};

const EstimationDatePicker = () => {
  const { setValue, getValues } = useFormContext();
  const [dateRange, setDateRange] = useState<DateRange<Moment>>(getDateRange(getValues('dateRange')?.split(' - ')));

  useEffect(() => {
    const [startDate, endDate] = dateRange;
    if (startDate && endDate) {
      setValue('daysInRange', endDate.diff(startDate, 'days') + 1);
    }
    setValue(
      'dateRange',
      dateRange[0] ? dateRangeToFormat(dateRange) : dateToFormat(moment(), DateFormat.DayShortMonthYear),
    );
  }, [dateRange, setValue]);

  return <DateRangeWithShortcuts value={dateRange} onChange={setDateRange} />;
};

export default EstimationDatePicker;
